module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00448.a05be2dd.jpg";